<template>
  <div v-loading="loadingExecutions">
    <div class="card">
      <div class="card-body" style="padding: 0;">
        <el-collapse v-model="activeExecutionCollapse" class="mt-3">
          <el-collapse-item v-for="execution in courtExecutions" :key="execution.id" :name="String(execution.id)">
            <template #title>
              <titles :text="`İcra - Məhkəmə işi №${execution.courtCaseNumber}`" />
            </template>

            <hr style="margin-top: 0; margin-bottom: 15px;" />
            <div class="row" style="color: #606266; font-size: 14px;">
              <div class="col-md-6 d-flex justify-content-between align-items-center mb-2">
                <div class="font-weight-bold me-2">Məsul şəxs:</div>
                <div class="flex-grow-1">{{ getRespName(execution.respUserId) || "(tapılmadı)" }}</div>
                <button type="button" size="sm" class="btn btn-outline-info mb-0"
                  @click="changeResponsibility(execution)">
                  <i class="fa fa-user-edit me-1"></i> Təyinatı dəyiş
                </button>
              </div>
            </div>

            <div v-if="execution.participants?.length" class="mt-3">
              <h6 class="fw-bold mb-2">Cavabdehlər</h6>
              <div class="row">
                <div class="col-md-6 mb-3" v-for="participant in execution.participants" :key="participant.id"
                  @click="handleParticipantDblClick(participant)">
                  <EnforcementParticipantCard :person="participant"
                    :obligation="{ has: participant.hasObligation, amount: participant.obligationAmount }"
                    :is-executor-view="true" @toggle-obligation="handleToggleObligation"
                    @obligation-updated="loadCourtExecutions" />
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- Öhdəlik dialog -->
    <el-dialog v-model="editParticipantDialogVisible" title="Öhdəlik məlumatı" width="35%" top="70px">
      <div class="mb-3">
        <label style="display: block; margin-left: 0px;" class="form-label">Öhdəlik var?</label>
        <el-switch v-model="participantToEdit.hasObligation" size="large" active-text="Bəli" inactive-text="Xeyr"
          :active-value="true" :inactive-value="false"
          style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
      </div>

      <div v-if="participantToEdit.hasObligation" class="mb-3">
        <label class="form-label">Öhdəlik məbləği</label>
        <el-input v-model="participantToEdit.obligationAmount" type="number" size="large" style="width: 100%;" />
      </div>

      <div class="d-flex justify-content-end mt-4">
        <soft-button type="button" @click="saveParticipantObligation">Yadda saxla</soft-button>
        &nbsp;
        <soft-button type="button" color="secondary" @click="editParticipantDialogVisible = false">İmtina</soft-button>
      </div>
    </el-dialog>
    <!-- Məsul şəxs təyinatı -->
    <el-dialog v-model="respDialogVisible" title="Məsul şəxs təyinatı" width="30%" top="200px">
      <el-select v-model="selectedUserId" placeholder="Seçin" size="large" style="width: 100%;">
        <el-option v-for="u in respUsers" :key="u.id" :label="u.name" :value="u.id" />
      </el-select>
      <div class="d-flex justify-content-end mt-4">
        <soft-button type="button" @click="saveResponsibility">Yadda saxla</soft-button>
        <soft-button color="secondary" type="button" @click="respDialogVisible = false" class="ms-2">İmtina</soft-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetCourtEnforcements, UpdateEnforcementExecutor } from "@/project/Source/courtenforcements";
import { GetCourtParticipants, UpdateCourtParticipant } from "@/project/Source/courtparticipants";
import { respUsers } from "@/project/Source/helper";
import Titles from "@/project/Components/Titles.vue";
import EnforcementParticipantCard from "./Components/EnforcementParticipantCard.vue";
import SoftButton from "@/components/SoftButton.vue";

export default {
  components: { Titles, EnforcementParticipantCard, SoftButton },
  props: {
    subrogationId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loadingExecutions: false,
      activeExecutionCollapse: [],
      courtExecutions: [],
      editParticipantDialogVisible: false,
      participantToEdit: null,
      respDialogVisible: false,
      selectedUserId: null,
      executionToEdit: null,
      respUsers
    };
  },
  mounted() {
    this.loadCourtExecutions();
  },
  methods: {
    getRespName(id) {
      const user = this.respUsers.find(u => u.id === id);
      return user ? user.name : "";
    },
    changeResponsibility(execution) {
      this.executionToEdit = execution;
      this.selectedUserId = execution.respUserId || null;
      this.respDialogVisible = true;
    },
    handleToggleObligation({ person, hasObligation }) {
      this.openEditParticipantDialog({ ...person, hasObligation });
    },
    handleParticipantDblClick(participant) {
      if (participant.hasObligation) {
        this.$router.push({
          name: 'EnforcementPayment',
          params: { participantId: participant.id, subrogationId: this.subrogationId },
          query: { courtCaseId: participant.courtCaseId }
        });
      }
    },
    async saveParticipantObligation() {
      try {
        await UpdateCourtParticipant({
          id: this.participantToEdit.id,
          name: this.participantToEdit.name,
          surname: this.participantToEdit.surname,
          fathername: this.participantToEdit.fatherName,
          pin: this.participantToEdit.pin,
          persontype: this.participantToEdit.personType,
          gender: this.participantToEdit.gender,
          birthdate: this.participantToEdit.birthDate,
          phone: this.participantToEdit.phone,
          additionalphone: this.participantToEdit.additionalPhone,
          workplace: this.participantToEdit.workPlace,
          regaddress: this.participantToEdit.regAddress,
          representative: this.participantToEdit.representative,
          tin: this.participantToEdit.tin,
          courtcaseid: this.participantToEdit.courtCaseId,
          user: this.$store.state.user.id,
          hasObligation: this.participantToEdit.hasObligation,
          obligationAmount: this.participantToEdit.obligationAmount
        });
        this.$message.success("Uğurlu əməliyyat!");
        this.editParticipantDialogVisible = false;
        this.loadCourtExecutions();
      } catch (error) {
        this.$message.error("Xəta baş verdi");
      }
    },
    openEditParticipantDialog(participant) {
      this.participantToEdit = { ...participant };
      this.editParticipantDialogVisible = true;
    },
    async loadCourtExecutions() {
      this.loadingExecutions = true;
      try {
        const response = await GetCourtEnforcements(this.subrogationId);
        const result = response.data.data.map(row => ({
          id: row.id,
          courtCaseId: row.courtCaseId,
          decisionId: row.decisionId,
          decisionAmount: row.decisionAmount,
          courtCaseNumber: row.courtCaseNumber,
          respUserId: row.respUserId || null,
          participants: null
        }));
        this.courtExecutions = result;
        this.$nextTick(() => {
          this.activeExecutionCollapse = result.map(e => String(e.id));
        });
        for (let execution of this.courtExecutions) {
          try {
            const res = await GetCourtParticipants(execution.courtCaseId);
            execution.participants = res.data.data;
          } catch {
            execution.participants = [];
          }
        }
      } catch (error) {
        console.error("Error loading court executions:", error);
      } finally {
        this.loadingExecutions = false;
      }
    },
    async saveResponsibility() {
      if (!this.executionToEdit || !this.selectedUserId) {
        this.$message.warning("Məsul şəxs seçin");
        return;
      }
      try {
        await UpdateEnforcementExecutor({
          id: this.executionToEdit.id,
          user: this.$store.state.user.id,
          respUserId: this.selectedUserId
        });
        this.executionToEdit.respUserId = this.selectedUserId;
        this.$message.success("Uğurlu əməliyyat!");
        this.respDialogVisible = false;
        this.executionToEdit = null;
        this.selectedUserId = null;
      } catch (error) {
        this.$message.error("Xəta baş verdi.");
      }
    }
  }
};
</script>
